import React, { Component, Fragment } from "react";
import IntlMessages from "Util/IntlMessages";
import { injectIntl } from "react-intl";
var classNames = require("classnames");
import StateButton from "Components/StateButton";
// const Diff = require('diff');

import { logoutUser } from "Redux/actions";
import { connect } from "react-redux";

import API from "../../api/index";
import Switch from "rc-switch";
import "rc-switch/assets/index.css";
import "react-sortable-tree/style.css";

import { Row, Button, Input, Card, CardBody, CardTitle, Modal, ModalBody, ModalHeader, ModalFooter } from "reactstrap";

import NumberFormat from "react-number-format";
import { Colxx } from "Components/CustomBootstrap";
import TextareaAutosize from "react-textarea-autosize";
import { NotificationManager } from "Components/ReactNotifications";

class SMSTrigger extends Component {
	constructor(props) {
		super(props);

		this.state = {
			SearchPhrase: "",
			isRefreshing: false,
			smsData: [],
			isLoading: true,
		};

		this.loadData = this.loadData.bind(this);
		this.loadData();
	}

	loadData(key) {
		API.sms
			.getList({ type: "TRIGGER" })
			.then((data) => {
				data.RELOGIN ? this.props.logoutUser(this.props.history) : 0;
				this.setState({
					smsData: data,
					isLoading: false,
					isRefreshing: false,
				});
			})
			.catch((error) => {});
	}

	render() {
		return this.state.isLoading ? (
			<div className="loading"></div>
		) : (
			<Fragment>
				<Row className="mb-4">
					<Colxx xxs="12">
						<Card>
							<CardBody>
								<CardTitle>
									<div className={"simple-icon-energy headingicon"} />
									پیام های اقدامی
									<Button
										className={"default mb-1"}
										outline
										color={"info"}
										style={{ float: "left", border: "unset", width: "40px", borderRadius: 50, padding: "10px" }}
										onClick={() => {
											this.setState({ isRefreshing: true });
											this.loadData();
										}}
									>
										<div className={" simple-icon-reload tableheadingicon"} />
									</Button>
									<div style={{ width: 200, float: "left", display: "inline-block", marginLeft: "10px", borderRadius: 50 }}>
										<Input
											autoComplete="off"
											type="text"
											name="SearchPhrase"
											id="SearchPhrase"
											color="info"
											placeholder=""
											value={this.state.SearchPhrase}
											onChange={(e) => {
												this.setState({ SearchPhrase: e.target.value });
											}}
											style={{ borderRadius: "50px", padding: "9px", lineHeight: "29px", paddingBottom: "5px", paddingTop: "7px", paddingLeft: "35px", paddingRight: "19px" }}
										/>
										<Button
											style={{
												position: "absolute",
												top: 22,
												marginRight: "165px",
												marginTop: "11px",
												fontSize: 20,
												padding: "5px",
												color: "lightgray",
												backgroundColor: "transparent",
												border: "unset",
												display: this.state.SearchPhrase != "" ? "block" : "none",
											}}
											onClick={(e) => {
												this.setState({ SearchPhrase: "" });
											}}
										>
											<i className="simple-icon-close"></i>
										</Button>
									</div>
								</CardTitle>
								{!this.state.isRefreshing ? (
									<div className="table-responsive table-stripped price-manager-table">
										<table className="table table-hover products-table">
											<thead>
												<tr>
													<th>#</th>
													<th>کد پیام</th>
													<th style={{ textAlign: "right" }}>متن پیام</th>
													<th style={{ textAlign: "right" }}>توضیحات</th>
													<th>فعال؟ </th>
													<th>عملیات </th>
												</tr>
											</thead>

											{this.state.smsData
												.filter((row) => {
													return this.state.SearchPhrase.trim() == ""
														? true
														: row.code.toLowerCase().indexOf(this.state.SearchPhrase.toLowerCase()) > -1 ||
																row.id.toLowerCase().indexOf(this.state.SearchPhrase.toLowerCase()) > -1 ||
																row.queue.toLowerCase().indexOf(this.state.SearchPhrase.toLowerCase()) > -1 ||
																("" + row.message).indexOf(this.state.SearchPhrase.replace(/[٠-٩]/g, (d) => "٠١٢٣٤٥٦٧٨٩".indexOf(d)).replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d))) > -1 ||
																row.description.indexOf(this.state.SearchPhrase.replace(/[٠-٩]/g, (d) => "٠١٢٣٤٥٦٧٨٩".indexOf(d)).replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d))) > -1;
												})
												.map((row, index) => (
													<TableBodyRows index={index} key={row.id} data={row} />
												))}
										</table>
									</div>
								) : (
									<div className="loading" style={{ left: "unset", top: "unset", position: "relative", display: "block", marginLeft: "auto", marginRight: "auto" }}></div>
								)}
							</CardBody>
						</Card>
					</Colxx>
				</Row>
			</Fragment>
		);
	}
}

class TableBodyRows extends Component {
	constructor(props) {
		super(props);

		this.state = {
			sendMobile: "",
			sendMessage: "",
			smsModalOpened: false,
			sms_isSending: false,
			id: this.props.data.id,
			failed: false,
			clicked: false,
			state: "new",
			active: this.props.data.active,
			initalActive: this.props.data.active,
			initialMessage: this.props.data.message.replace(/\r/g, ""),
			message: this.props.data.message.replace(/\r/g, ""),
		};
		this.smsModalToggle = this.smsModalToggle.bind(this);
		this.smsSend = this.smsSend.bind(this);
		this.handleSaveButtonClick = this.handleSaveButtonClick.bind(this);
	}
	smsSend() {
		this.setState({ sms_isSending: true });
		API.sms
			.send({ IS_TEST: true, MESSAGE_ID: this.state.id, USER_ID: false })
			.then((data) => {
				data.RELOGIN ? this.props.logoutUser(this.props.history) : 0;
				if (data.done) {
					this.setState({
						sendMobile: data.mobile,
						sendMessage: data.message,
						sms_isSending: false,
						smsModalOpen: true,
					});
				} else {
					setTimeout(
						function (err) {
							NotificationManager.error(err, "مشکل در ارسال پیامک تست", 8000, null, null, "filled");
						},
						700,
						data.message
					);
				}
				this.setState({
					sms_isSending: false,
				});
			})
			.catch((error) => {
				setTimeout(
					function (err) {
						NotificationManager.error(err, "مشکل در ارسال پیامک به سرور", 8000, null, null, "filled");
					},
					700,
					error.message
				);
			});
	}
	smsModalToggle() {
		this.setState({
			smsModalOpen: !this.state.smsModalOpen,
		});
	}
	handleSaveButtonClick() {
		this.setState({ clicked: true, failed: false });

		return new Promise((success, fail, $this) => {
			setTimeout(($this) => {
				API.sms
					.updateItem({ ID: this.state.id, MESSAGE: this.state.message, ACTIVE: this.state.active })
					.then((data) => {
						data.RELOGIN ? this.props.logoutUser(this.props.history) : 0;
						if (data.DONE == true) {
							success("تغییرات ثبت شد");
							setTimeout(() => {
								this.setState({ initalActive: this.state.active, initialMessage: this.state.message, clicked: false, failed: false });
							}, 2000);
						} else {
							this.setState({ clicked: false, failed: true });
							fail("مشکل در ذخیره تغییرات");
						}
					})
					.catch((error) => {
						this.setState({ clicked: false, failed: true });
						fail("مشکل در ذخیره تغییرات");
					});
			}, 10);
		});
	}

	render() {
		const {
			data: { id, code, message, description, active,queue },
		} = this.props;
		var paymentColorClass = this.state.status == "new" ? "white" : "lightgreen";
		var btnColor = "primary";
		if (this.state.message == this.state.initialMessage && this.state.active == this.state.initalActive && !this.state.failed) {
			btnColor = "light";
		}
		if (this.state.failed) {
			btnColor = "danger";
		}

		return (
			<tbody
				className={classNames({
					"saving-row": this.state.clicked,
				})}
			>
				<tr className={"order-spacer"}></tr>
				<tr className={"product-item"}>
					<td> {this.props.index + 1} </td>
					<td> {id} </td>
					<td style={{ textAlign: "right" }}>
						<TextareaAutosize
							spellCheck={false}
							style={{ width: "100%", padding: "10px", borderRadius: "10px", background: "#e5e5ea", borderBottomLeftRadius: "0", lineHeight: "20px" }}
							disabled={this.state.clicked}
							onChange={(event) => {
								this.setState({ message: event.target.value.replace(/\r/g, "") });
								// console.log(Diff.diffChars(this.state.initialMessage,event.target.value));
							}}
							defaultValue={this.state.message}
						/>
					</td>
					<td style={{ textAlign: "right" }}>
						<span style={{ fontFamily: "courier", color: "lightgray" }}>{code}</span>
						<br />
						<span style={{ fontFamily: "courier", color: "lightgray" }}>{queue}</span>
						<br />
						{description}
					</td>

					<td style={{ textAlign: "center" }}>
						<Switch
							style={{ marginLeft: "auto", marginRight: "auto" }}
							className="custom-switch custom-switch-primary"
							checked={this.state.active}
							disabled={this.state.clicked}
							onChange={(active) => {
								this.setState({ active });
							}}
						/>
					</td>

					<td className={"text-muted"}>
						<StateButton
							key={"statebtn-" + id}
							id={"cardButton" + id}
							placement="right"
							className={"default md-2"}
							color={btnColor}
							style={{ float: "left" }}
							disabled={this.state.message == this.state.initialMessage && this.state.active == this.state.initalActive}
							onClick={this.handleSaveButtonClick}
						>
							ذخیره
						</StateButton>
						<Button
							color="info"
							style={{ float: "left", padding: 5, paddingTop: 8 }}
							key={"testbtn-" + id}
							id={"testButton" + id}
							placement="right"
							className={"default md-2"}
							disabled={this.state.message != this.state.initialMessage || this.state.sms_isSending}
							onClick={() => {
								this.smsSend();
							}}
						>
							<i
								className="iconsminds-mail-send"
								style={{
									fontSize: 24,
									fontWeight: 800,
									height: 20,
									display: "inline-block",
								}}
							></i>
							&nbsp;
						</Button>
						<Modal onOpened={this.smsModalOpened} isOpen={this.state.smsModalOpen} toggle={this.smsModalToggle}>
							<ModalHeader toggle={this.smsModalToggle}>پیامک تست ارسال شد</ModalHeader>
							<ModalBody>
								<table>
									<tbody>
										<tr>
											<th>موبایل:</th>
											<td>{this.state.sendMobile}</td>
										</tr>

										<tr>
											<th>پیام:</th>
											<td>
												<div
													style={{ background: "#e5e5ea", width: "400px", padding: "10px", borderRadius: "10px", float: "Left", borderBottomLeftRadius: "" }}
													dangerouslySetInnerHTML={{
														__html: this.state.sendMessage,
													}}
												></div>
											</td>
										</tr>
									</tbody>
								</table>
							</ModalBody>
						</Modal>
					</td>
				</tr>
			</tbody>
		);
	}
}

const mapStateToProps = ({ menu, settings }) => {
	return { logoutUser };
};
export default injectIntl(connect(mapStateToProps, { logoutUser })(SMSTrigger));
// export default injectIntl(ProductPriceManager);
